import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'formatTimeAgo',
    standalone: false
})

export class FormatTimeAgoPipe implements PipeTransform {
    private arabicDigits = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];

    constructor(private translate: TranslateService) {
    }

    transform(value: any): any {
        // const date = new Date(value.replace(' ', 'T') + (value && value.indexOf('Z') < 0 ? 'Z' : ''));
        const date = new Date(value);
        const now = new Date();
        const diff = now.getTime() - date.getTime();
        const years = Math.floor(diff / (60 * 60 * 1000 * 24 * 365));
        const months = Math.floor(diff / (60 * 60 * 1000 * 24 * 30));
        const weeks = Math.floor(diff / (60 * 60 * 1000 * 24 * 7));
        const days = Math.floor(diff % (60 * 60 * 1000 * 24 * 7) / (60 * 60 * 1000 * 24));
        const hours = Math.floor((diff % (60 * 60 * 1000 * 24)) / (60 * 60 * 1000));
        const mins = Math.floor(((diff % (60 * 60 * 1000 * 24)) % (60 * 60 * 1000)) / (60 * 1000));
        const secs = Math.floor(((diff % (60 * 60 * 1000 * 24)) % (60 * 60 * 1000)) % (60 * 1000) / 1000);

        if (years > 0) {
            return this.convert(years, 'years');
        }
        else if (months > 0) {
            return this.convert(months, 'months');
        }
        else if (weeks > 0) {
            return this.convert(weeks, 'weeks');
        }
        else if (days > 0) {
            return this.convert(days, 'days');
        }
        else if (hours > 0) {
            return this.convert(hours, 'hours');
        }
        else if (mins > 0) {
            return this.convert(mins, 'mins');
        }
        else if (secs > 0) {
            return this.convert(secs, 'secs');
        }

        return this.translate.instant('date.now');
    }

    private convert(num: number, unit: string): string {
        const lang = this.translate.currentLang || 'en';
        const key = `date.${unit}`;

        let form = 'other';
        if (lang === 'ar') {
            if (num === 1) form = 'one';
            else if (num === 2) form = 'two';
            else if (num >= 3 && num <= 10) form = 'few';
            else form = 'many';
        } else {
            form = num === 1 ? 'one' : 'other';
        }

        const translation = this.translate.instant(`${key}.${form}`);
        let result = translation.replace('$value', num.toString());

        if (lang === 'ar') {
            result = this.toArabicDigits(result);
        }

        return result;
    }

    private toArabicDigits(value: string): string {
        return value.replace(/\d/g, d => this.arabicDigits[+d]);
    }
}
